const frontCommonLanguages = [
    {
        value: 'fr_FR',
        flag: 'fr',
    },
    {
        value: 'en_GB',
        flag: 'gb',
    },
    {
        value: 'nl_NL',
        flag: 'nl',
    },
];

/**
 * Generated bundle index. Do not edit.
 */

export { frontCommonLanguages };
